<template>
  <div
      class="inputBoxWrap"
      v-bind:class="{'disableField':disableField}"
  >
    <input
        v-model="value"
        :placeholder="item.placeholder"
        v-on:blur="eventBlur"
        v-on:focus="eventFocus"
        v-bind:style="colorBorder"
        v-on:keydown="selectSuggestion($event)"
    >
    <div
        class="suggestions"
        v-show="suggestions.length > 0"
    >
      <p
          class="items"
          v-for="(item, index) in suggestions" :key="index"
          v-on:click="onSearchItemSelected(item)"
          v-bind:class="{hover: activeIndex === index}"
      >
        {{item.value}}
      </p>
    </div>

      <label v-bind:class="{active: focused}">{{item.label}}</label>
      <p class="errorMsg" v-if="statusVuex[refs].ShowError">{{errorMsg}}</p>
  </div>
</template>

<script>
  import DataForInput from '@/store/Form/longFormOptions';
  import {mapState} from 'vuex';

  export default {
    name: "vmSelectDadata",
    props: {
      refs: {
        type: String,
        default: 'null'
      },
    },
    data() {
      return {
        activeIndex: 0,
        suggestions: [],
        focused: false,
        query: '',
        selectedSearchItem: null,
        item: DataForInput[this.refs],
      }
    },
    components: {
    },
    methods: {
      selectSuggestion(event) {
          switch (event.key) {
            case 'ArrowUp':
              if (this.activeIndex > 0) {
                this.activeIndex -= 1
              }
              break;
            case 'ArrowDown':
              if (this.activeIndex < (this.suggestions.length -1)) {
                this.activeIndex += 1
              }
              break;
            case 'Enter':
              this.onSearchItemSelected(this.suggestions[this.activeIndex])
              break;
            default: break
          }
      },
      eventBlur() {
        if(process.env.NODE_ENV == 'development') {
          console.log('eventBlur');
        }
        this.$store.dispatch('errorShow', {
          target: this.refs,
          value: true,
        });
        this.$external.traceInput({
          action:165,
          refs:this.refs,
          value:this.valueVuex[this.refs]
        });
        setTimeout(()=>{
          this.suggestions = []
        }, 300)
      },
      eventFocus() {
        this.$store.dispatch('errorShow', {
          target: this.refs,
          value: false,
        });
        this.$external.traceInput({
          action:164,
          refs:this.refs,
          value:this.valueVuex[this.refs]
        });
      },
      onInputChange(query) {
        if (query.trim().length === 0) {
          return null
        }
        if (this.refs === 'PASSPORT_DEP' && this.valueVuex.PASSPORT_DEP_CODE.length > 0) {
          query = this.valueVuex.PASSPORT_DEP_CODE
        }

        if (this.refs === 'WORK_TITLE') {
          return new Promise(resolve => {
            this.$myApi.suggestResultGigData(query, 5)
              .then(resp => {
                let suggestions = resp.data.suggestions;
                let result = (Array.isArray(suggestions) && suggestions.length) ? suggestions : [];
                resolve(this.suggestions = result);
              })
              .catch(err => {
                console.error("Ошибка при запросе suggestResultGigData", err);
              });
          });
        } else {
          const searchType = this.refs === 'WORK_JOB_ADRESS' ? 'REGISTRATION_ADDRESS' : this.refs;

          return new Promise(resolve => {
            this.$myApi.suggestResult(
                searchType,
                {'value': query, 'type': searchType}
            ).then(resp => {
              let dadataSuggest = resp.data.result.suggestions;
              let result = (Array.isArray(dadataSuggest) && dadataSuggest.length) ? dadataSuggest : [];
              resolve(this.suggestions = result);
            });
          });
        }
      },
      onSearchItemSelected(item) {
        this.selectedSearchItem = item;
        this.query = item.value;

        this.$store.dispatch('saveSendData', {
          target: this.refs,
          value: item.value,
          jsonSuggestion:item
        });
        this.namesGenderToStorage(item);
        this.dadataAddressToStorage(item);
        this.suggestions = [];
      },
      dadataAddressToStorage(item) {
        if (this.refs.indexOf('_ADDRESS') > 0 || this.refs.indexOf('_JOB') > 0 ) {
          this.$store.dispatch('saveSendData', {
            target: this.refs + '_DADATA',
            value: item,
          });
        }
      },
      namesGenderToStorage(item) {
        if (this.refs.indexOf('NAME') > 0) {
          if (item?.data?.gender === 'MALE') {
            this.$store.dispatch('saveSendData', {
              target: 'GENDER',
              value: 'M',
            });
          } else if (item?.data?.gender === 'FEMALE') {
            this.$store.dispatch('saveSendData', {
              target: 'GENDER',
              value: 'F',
            });
          } else {
            return false
          }
        }
      }
    },
    computed: {
      ...mapState({
        statusVuex: state => state.Form.workData,
        valueVuex: state => state.Form.sendData,
      }),
      disableField(){
        //если поле нельзя редактировать, сообщаем об этом в компонент
        return this.statusVuex[this.refs].disable;
      },
      status() {
        return this.statusVuex[this.refs].code;
      },
      errorMsg() {
        return this.statusVuex[this.refs].msg;
      },
      showErrorMessage() {
        return this.statusVuex[this.refs].ShowError;
      },
      colorBorder() {
        return (this.showErrorMessage && this.status !== 0) ? 'border-color:#ff00003d;' :'border-color: rgba(67, 172, 52, 0.5);';
      },
      value: {
        get() {
          this.$external.traceInput({
            action:165,
            refs:this.refs,
            value:this.valueVuex[this.refs]
          });
          return this.valueVuex[this.refs]
        },
        set(value) {
          // if (this.refs === 'WORK_TITLE') {
            this.onInputChange(value);
          // } else {
          //   this.onInputChange(value);
          // }
          let utiputi = {
            target: this.refs,
            value: value
          };
          this.$store.dispatch('saveSendData', utiputi);
        }
      },
    },
  }
</script>

<style scoped>
.active { top:-3vw }
.suggestions { position: absolute; left: 0; top: 10vw; width: 100%; z-index: 100; background: #ffffff; border: 1px solid #EEE; margin: 0; padding: 0 }
.items { border-bottom: 1px solid #eee; padding: 1vw }
@media (min-width: 760px) {
  .suggestions { top: 3vw }
  .items {padding: 0.5vw }
}
@media (min-width: 1240px) {
  .active { top: -10px }
  .suggestions { top: 36px;}
  .items {padding: 5px }
  .items:hover, .hover { background: #eee; cursor: pointer; }

}
.disableField{pointer-events: none;opacity: 0.5}
</style>
